import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, CalendarDays, PartyPopper, ListChecks, Users, Sparkles, Package, ShoppingCart,
  Contact, Wallet, Settings, LogOut, Menu, ExternalLink,
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";

const NAV = [
  { to: "/manager", icon: LayoutDashboard, label: "Inicio", end: true },
  { to: "/manager/agenda", icon: CalendarDays, label: "Agenda" },
  { to: "/manager/eventos", icon: PartyPopper, label: "Eventos" },
  { to: "/manager/tareas", icon: ListChecks, label: "Tareas" },
  { to: "/manager/personal", icon: Users, label: "Personal" },
  { to: "/manager/limpieza", icon: Sparkles, label: "Limpieza" },
  { to: "/manager/inventario", icon: Package, label: "Inventario" },
  { to: "/manager/compras", icon: ShoppingCart, label: "Compras y proveedores" },
  { to: "/manager/crm", icon: Contact, label: "Interesados (CRM)" },
  { to: "/manager/finanzas", icon: Wallet, label: "Finanzas" },
  { to: "/manager/configuracion", icon: Settings, label: "Configuración" },
];

function NavItems({ onNavigate }) {
  return (
    <nav className="flex flex-col gap-0.5">
      {NAV.map(({ to, icon: Icon, label, end }) => (
        <NavLink key={to} to={to} end={end} onClick={onNavigate} data-testid={`mgr-nav-${to.split("/")[2] || "inicio"}`}
          className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors ${
            isActive ? "bg-[#BBA77D] text-[#101B28] font-medium" : "text-[#F7F5F0]/75 hover:bg-white/5 hover:text-[#F7F5F0]"}`}>
          <Icon size={17} /> {label}
        </NavLink>
      ))}
    </nav>
  );
}

function SidebarBody({ onNavigate }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-full p-5">
      <div className="mb-8 px-2">
        <p className="font-display text-2xl text-[#F7F5F0] tracking-tight">AURA <span className="text-[#BBA77D]">Manager</span></p>
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#F7F5F0]/40 mt-1">Operations Hub</p>
      </div>
      <NavItems onNavigate={onNavigate} />
      <div className="mt-auto pt-6 border-t border-white/10 space-y-2 text-xs text-[#F7F5F0]/60">
        <a href="/admin" className="flex items-center gap-2 px-2 hover:text-[#BBA77D]" data-testid="mgr-link-web-admin"><ExternalLink size={13} /> Admin de la web</a>
        <p className="px-2 truncate" data-testid="mgr-user-email">{user?.email}</p>
        <button onClick={async () => { await logout(); navigate("/manager/login"); }} data-testid="mgr-logout"
          className="flex items-center gap-2 px-2 hover:text-[#BBA77D]"><LogOut size={13} /> Cerrar sesión</button>
      </div>
    </div>
  );
}

export default function ManagerLayout({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#F7F5F0] text-[#101B28]" data-testid="manager-app">
      <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 bg-[#101B28]"><SidebarBody /></aside>
      <header className="lg:hidden sticky top-0 z-30 bg-[#101B28] px-4 py-3 flex items-center justify-between">
        <p className="font-display text-xl text-[#F7F5F0]">AURA <span className="text-[#BBA77D]">Manager</span></p>
        <button onClick={() => setOpen(true)} className="text-[#F7F5F0]" data-testid="mgr-mobile-menu" aria-label="Menú"><Menu /></button>
      </header>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="bg-[#101B28] border-none p-0 w-72 [&>button]:text-white [&>button]:opacity-90">
          <SheetTitle className="sr-only">Menú</SheetTitle>
          <SidebarBody onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
      <main className="lg:pl-64"><div className="max-w-7xl mx-auto px-4 md:px-8 py-8">{children}</div></main>
    </div>
  );
}
